import { Controller } from "@hotwired/stimulus";
import { resolveTodo } from "../../todo_list/todo_resolver";

export default class extends Controller {
  static targets = ["historicalAccountingEntriesFileUploaded", "historicalTaxReturnFileUploaded"];

  static values = {
    todoId: Number,
  };

  historicalAccountingEntriesFileUploadedTargetConnected() {
    this._checkTodoResolution();
  }

  historicalTaxReturnFileUploadedTargetConnected() {
    this._checkTodoResolution();
  }

  _checkTodoResolution() {
    if (this.hasHistoricalAccountingEntriesFileUploadedTarget && this.hasHistoricalTaxReturnFileUploadedTarget) {
      resolveTodo(this.todoIdValue);
    }
  }
}
